/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { useQuery } from 'react-query';
import type {
    InvalidateOptions,
    QueryClient,
    QueryFunction,
    QueryKey,
    UseQueryOptions,
    UseQueryResult,
} from 'react-query';

import { customFetchInstance } from '../../../../../../orval/client/custom-fetch';
import { getCustomQueryOptions } from '../../../../../../orval/mutator/custom-query-options';
import { APIImportFilter, PaginatedAPIImportList } from '../../models';
import type {
    ApiApiImportFiltersRetrieveParams,
    ApiApiImportListParams,
} from '../../models';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K,
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key !== 'queryKey') {
            Object.defineProperty(result, key, {
                enumerable: true,
                configurable: true,
                get: () => (query as Record<string, unknown>)[key],
            });
        }
    }
    return result;
};

export const getApiApiImportListUrl = (params?: ApiApiImportListParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(
                key,
                value === null ? 'null' : String(value),
            );
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `${process.env.ORVAL_API_BASE_URL}/api/api_import/?${stringifiedParams}`
        : `${process.env.ORVAL_API_BASE_URL}/api/api_import/`;
};

export const apiApiImportList = async (
    params?: ApiApiImportListParams,
    options?: RequestInit,
): Promise<PaginatedAPIImportList> => {
    return customFetchInstance<PaginatedAPIImportList>(
        getApiApiImportListUrl(params),
        {
            credentials: 'same-origin',
            ...options,
            method: 'GET',
        },
    );
};

export const getApiApiImportListQueryKey = (
    params?: ApiApiImportListParams,
) => {
    return ['apiApiImportList', ...(params ? [params] : [])] as const;
};

export const useApiApiImportListQueryOptions = <
    TData = Awaited<ReturnType<typeof apiApiImportList>>,
    TError = unknown,
>(
    params?: ApiApiImportListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiApiImportList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getApiApiImportListQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof apiApiImportList>>
    > = ({ signal }) => apiApiImportList(params, { signal, ...requestOptions });

    const customOptions = getCustomQueryOptions({
        queryKey,
        queryFn,
        ...queryOptions,
    });

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<typeof apiApiImportList>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type ApiApiImportListQueryResult = NonNullable<
    Awaited<ReturnType<typeof apiApiImportList>>
>;
export type ApiApiImportListQueryError = unknown;

export function useApiApiImportList<
    TData = Awaited<ReturnType<typeof apiApiImportList>>,
    TError = unknown,
>(
    params?: ApiApiImportListParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiApiImportList>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useApiApiImportListQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const invalidateApiApiImportList = async (
    queryClient: QueryClient,
    params?: ApiApiImportListParams,
    options?: InvalidateOptions,
): Promise<QueryClient> => {
    await queryClient.invalidateQueries(
        {
            queryKey: getCustomQueryOptions({
                queryKey: getApiApiImportListQueryKey(params),
            }).queryKey,
        },
        options,
    );

    return queryClient;
};

export const getApiApiImportExportToCsvRetrieveUrl = () => {
    return `${process.env.ORVAL_API_BASE_URL}/api/api_import/export_to_csv/`;
};

export const apiApiImportExportToCsvRetrieve = async (
    options?: RequestInit,
): Promise<Blob> => {
    return customFetchInstance<Blob>(getApiApiImportExportToCsvRetrieveUrl(), {
        credentials: 'same-origin',
        ...options,
        method: 'GET',
    });
};

export const getApiApiImportExportToCsvRetrieveQueryKey = () => {
    return ['apiApiImportExportToCsvRetrieve'] as const;
};

export const useApiApiImportExportToCsvRetrieveQueryOptions = <
    TData = Awaited<ReturnType<typeof apiApiImportExportToCsvRetrieve>>,
    TError = unknown,
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<typeof apiApiImportExportToCsvRetrieve>>,
        TError,
        TData
    >;
    request?: SecondParameter<typeof customFetchInstance>;
}) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getApiApiImportExportToCsvRetrieveQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof apiApiImportExportToCsvRetrieve>>
    > = ({ signal }) =>
        apiApiImportExportToCsvRetrieve({ signal, ...requestOptions });

    const customOptions = getCustomQueryOptions({
        queryKey,
        queryFn,
        ...queryOptions,
    });

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<typeof apiApiImportExportToCsvRetrieve>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type ApiApiImportExportToCsvRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof apiApiImportExportToCsvRetrieve>>
>;
export type ApiApiImportExportToCsvRetrieveQueryError = unknown;

export function useApiApiImportExportToCsvRetrieve<
    TData = Awaited<ReturnType<typeof apiApiImportExportToCsvRetrieve>>,
    TError = unknown,
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<typeof apiApiImportExportToCsvRetrieve>>,
        TError,
        TData
    >;
    request?: SecondParameter<typeof customFetchInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions =
        useApiApiImportExportToCsvRetrieveQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const invalidateApiApiImportExportToCsvRetrieve = async (
    queryClient: QueryClient,
    options?: InvalidateOptions,
): Promise<QueryClient> => {
    await queryClient.invalidateQueries(
        {
            queryKey: getCustomQueryOptions({
                queryKey: getApiApiImportExportToCsvRetrieveQueryKey(),
            }).queryKey,
        },
        options,
    );

    return queryClient;
};

export const getApiApiImportFiltersRetrieveUrl = (
    params?: ApiApiImportFiltersRetrieveParams,
) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(
                key,
                value === null ? 'null' : String(value),
            );
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `${process.env.ORVAL_API_BASE_URL}/api/api_import/filters/?${stringifiedParams}`
        : `${process.env.ORVAL_API_BASE_URL}/api/api_import/filters/`;
};

export const apiApiImportFiltersRetrieve = async (
    params?: ApiApiImportFiltersRetrieveParams,
    options?: RequestInit,
): Promise<APIImportFilter> => {
    return customFetchInstance<APIImportFilter>(
        getApiApiImportFiltersRetrieveUrl(params),
        {
            credentials: 'same-origin',
            ...options,
            method: 'GET',
        },
    );
};

export const getApiApiImportFiltersRetrieveQueryKey = (
    params?: ApiApiImportFiltersRetrieveParams,
) => {
    return [
        'apiApiImportFiltersRetrieve',
        ...(params ? [params] : []),
    ] as const;
};

export const useApiApiImportFiltersRetrieveQueryOptions = <
    TData = Awaited<ReturnType<typeof apiApiImportFiltersRetrieve>>,
    TError = unknown,
>(
    params?: ApiApiImportFiltersRetrieveParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiApiImportFiltersRetrieve>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getApiApiImportFiltersRetrieveQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof apiApiImportFiltersRetrieve>>
    > = ({ signal }) =>
        apiApiImportFiltersRetrieve(params, { signal, ...requestOptions });

    const customOptions = getCustomQueryOptions({
        queryKey,
        queryFn,
        ...queryOptions,
    });

    return customOptions as UseQueryOptions<
        Awaited<ReturnType<typeof apiApiImportFiltersRetrieve>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type ApiApiImportFiltersRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof apiApiImportFiltersRetrieve>>
>;
export type ApiApiImportFiltersRetrieveQueryError = unknown;

export function useApiApiImportFiltersRetrieve<
    TData = Awaited<ReturnType<typeof apiApiImportFiltersRetrieve>>,
    TError = unknown,
>(
    params?: ApiApiImportFiltersRetrieveParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof apiApiImportFiltersRetrieve>>,
            TError,
            TData
        >;
        request?: SecondParameter<typeof customFetchInstance>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = useApiApiImportFiltersRetrieveQueryOptions(
        params,
        options,
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const invalidateApiApiImportFiltersRetrieve = async (
    queryClient: QueryClient,
    params?: ApiApiImportFiltersRetrieveParams,
    options?: InvalidateOptions,
): Promise<QueryClient> => {
    await queryClient.invalidateQueries(
        {
            queryKey: getCustomQueryOptions({
                queryKey: getApiApiImportFiltersRetrieveQueryKey(params),
            }).queryKey,
        },
        options,
    );

    return queryClient;
};
